module.exports = __webpack_public_path__ + "static/media/20.450ec9a3.jpg";